























import toastr from 'toastr';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ShopErrors } from '../../enums/ShopErrors';
import { updateCart as updateCartService } from '../../utils/shop/http-services';
// @ts-ignore
import imageService from '../../services/imageService';

@Component
export default class CartOverviewWidget extends Vue {
  @Prop() product!: object;
  @Prop() imageleft!: string;
  @Prop() variantid!: string;
  @Prop() csrftoken!: string;
  @Prop() cartlink!: string;

  submitting = false;
  qty = 1;

  amountUpdated(variantId: number, qty: number): void {
    this.qty = qty;
  }

  getTransformedSrcSet(image: any): any {
    return imageService.getTransformedSrcSet(image);
  }

  addToCart(): void {
    const formData = new FormData();
    formData.append('purchasableId', this.variantid);
    formData.append('qty', this.qty as any);

    this.submitting = true;
    updateCartService(this.csrftoken, formData)
    .then(({ data }) => {
      if (data.errors) {
        if (Object.keys(data.errors).some(k => k.endsWith(ShopErrors.NOT_AVAILABLE)))
          throw new Error(this.$t('SHOP.ERRORS.OUT_OF_STOCK') as string);
        throw new Error(this.$t('SHOP.ERRORS.ADDING_TO_CART_FAILED') as string);
      }

      toastr.options = { progressBar: true, tapToDismiss: false };
      toastr.success(
          `<div>${this.$t('SHOP.CART.PRODUCT_ADDED_TO_CART')}<br /><br />
                    <a href="${this.cartlink}" title="${this.$t('SHOP.CART.GO_TO_CART',)}}">${this.$t('SHOP.CART.GO_TO_CART')}</a></div>`,
          this.$t('SHOP.CART.UPDATE_SUCCESSFUL') as string,
      );
      this.qty = 1;
      this.onProductAddedToCart(data.cart);
    })
    .catch(error => {
      toastr.options = { progressBar: true };
      toastr.error(error.message, this.$t('SHOP.ERRORS.FAILED') as string);
    })
    .finally(() => {
      this.submitting = false;
    });
  }

  onProductAddedToCart(cart: any): void {
    const event = new CustomEvent('product-added', { detail: { cart } });
    window.dispatchEvent(event);
  }
}
